import axios from "axios";

export default async function postApi(path, body) {
  if (!import.meta.env.VITE_SERVER_BASE)
    throw new Error("API server not configure");
  const { data } = await axios.post(
    import.meta.env.VITE_SERVER_BASE + path,
    body
  );
  return data;
}
